import { apiCase } from '../../../http';

class LoginConfigurationService {
  saveLoginConfigurations(data) {
    return apiCase.put(`/login-configuration`, data);
  }

  getLoginConfigurations() {
    return apiCase.get(`/login-configuration`);
  }
}

export default new LoginConfigurationService();
